<template>
    <v-radio-group
        v-bind="orientation()"
        :label="label"
        v-model="formValues[field.nombre]"
        :rules="rules"
        class="pt-0 mt-0"
    >
        <v-row v-if="!$vuetify.breakpoint.mobile && isInColumns()">
            <v-col :cols="getNumberOfCols()" v-for="option in field.datos" :key="option.valor">
                <v-checkbox
                    color="main_color"
                    :label="option.etiqueta"
                    :value="option.valor"
                    v-model="internalValue"
                    hide-details
                    class="mt-0"
                    :readonly="readonly"
                ></v-checkbox>
            </v-col>
        </v-row>

        <v-checkbox
            color="main_color"
            v-else v-for="option in field.datos"
            v-model="internalValue"
            :label="option.etiqueta"
            :value="option.valor"
            :key="option.valor"
            hide-details
            v-bind:class="{'mr-4': isHorizontal}"
            :readonly="readonly"
        />
        <div v-if="field.ayuda != ''" class="text-body-2 grey--text">{{field.ayuda}}</div>
    </v-radio-group>
</template>

<script>
    import procedureFormValidator from "@/form/procedure.form.validator";

    export default {
        name: "Checkbox",
        props: ['field', 'label', 'readonly', 'formValues', 'dynamicTable'],
        data(){
            return {
                rules: [procedureFormValidator.checkbox_group.required(this.field.validacion.required, this.readonly)],
                internalValue: []
            }
        },

        watch: {
            internalValue(value) {
                if (!this.dynamicTable){
                    this.formValues[this.field.nombre] = JSON.stringify(value)
                }
            }
        },
        mounted() {
            if (this.formValues[this.field.nombre] && !Array.isArray(this.formValues[this.field.nombre])){
                this.formValues[this.field.nombre] = JSON.parse(this.formValues[this.field.nombre])
            }

            if (this.formValues[this.field.nombre] == null){
                this.formValues[this.field.nombre] = []
            }/*else{
                if (!Array.isArray(this.formValues[this.field.nombre])){
                    this.formValues[this.field.nombre] = this.formValues[this.field.nombre].split(',')
                }
            }*/

            this.internalValue = this.formValues[this.field.nombre]
        },

        methods: {
            orientation(){
                let isHorizontal = this.field.extra.orientacion && this.field.extra.orientacion == 'horizontal'
                return {
                    row: isHorizontal,
                    column: !isHorizontal
                }
            },

            isInColumns(){
                let orientation = this.field.extra.orientacion
                if (orientation && (orientation == 'horizontal' || orientation == 'vertical')){
                    return false
                }

                return true
            },

            getNumberOfCols(){
                let orientation = this.field.extra.orientacion
                if (orientation == 'dos_columnas'){
                    return 6;
                }
                else if (orientation == 'tres_columnas'){
                    return 4;
                }
                else if (orientation == 'cuatro_columnas'){
                    return 3;
                }

                return 12
            },

            isHorizontal(){
                return this.orientation().column
            }
        },
    }
</script>